export const USER_LIST = 'USER_LIST';
export const USER_INFO = 'USER_INFO'; 
export const ADMIN_UPDATE_USER = 'ADMIN_UPDATE_USER'; 


